module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Light-66ca0d348773c8c516a88f6486830508.svg";